/**
 * Page-team template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";
import Logger from "./lib/logger";
import UnderConstruction from "./lib/page-under-construction";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Page-Team";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

// Bootstrap global functionality
Global();

/**
 * Init
 **/
const init = () => {
	Logger.info(`${NAME} > init...`);
	ModalCall();
	UnderConstruction;
};

const ModalCall = () => {
	Logger.info(`${NAME} > initModalModule...`);

	const modal = document.querySelectorAll(".modal");
	const overlay = document.querySelector(".overlay");
	const openModalBtn = document.querySelectorAll(".btn[data-modal]");
	const closeModalBtn = document.querySelectorAll(".btn-close");

	const openModal = function () {
		document.body.dataset.modalMode = true;
		document.documentElement.dataset.modalMode = true;
		let selectedModal = document.querySelector(
			".modal[data-modal=" + this.dataset.modal + "]"
		);
		selectedModal.classList.remove("hidden");
		overlay.classList.remove("hidden");
	};

	openModalBtn.forEach((item) => {
		item.addEventListener("click", openModal);
	});

	const closeModal = function () {
		overlay.classList.add("hidden");

		modal.forEach((item) => {
			item.classList.add("hidden");
		});
	};

	closeModalBtn.forEach((item) => {
		document.body.dataset.modalMode = false;
		document.documentElement.dataset.modalMode = false;
		item.addEventListener("click", closeModal);
	});

	overlay.addEventListener("click", closeModal);

	document.addEventListener("keydown", function (e) {
		if (e.key === "Escape" && !modal.classList.contains("hidden")) {
			modalClose();
		}
	});
};


init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
